import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { FULL_WIDTH_INLINE_VIDEO_CONVERTER_TOKEN, FullWidthInlineVideoConverter } from './full-width-inline-video.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        fullWidthInlineVideoFeature: {
          module: () => import('./full-width-inline-video.module').then((m) => m.FullWidthInlineVideoModule),
          cmsComponents: ['full_width_inline_video'],
        },
      }
    }),
    {
      provide: FULL_WIDTH_INLINE_VIDEO_CONVERTER_TOKEN,
      useExisting: FullWidthInlineVideoConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        full_width_inline_video: FULL_WIDTH_INLINE_VIDEO_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class FullWidthInlineVideoFeatureModule {}
